import syllabusService from './syllabus.Service';

export default syllabusService;
